/**
 * ./exercise7/Exercise7Intro.js
 * 
 * This module is similar with previous exercises. 
 * 
 */

import React, { useEffect, useState } from "react";
import "../exercise1/Exercise1Intro.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";
import IconBubble from "../components/IconBubble/IconBubble";
import Star2 from "../components/icons/star2.svg";
import { API_BASE_URL } from "../config";

const Exercise7Intro = () => {
  const navigate = useNavigate();

  const [canStart, setCanStart] = useState(false);
  const [selectedLevel, setSelectedLevel] = useState(2);
  const [sunnyHTML, setSunnyHTML] = useState(`<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
    Select an article to read.
  </span>`);
  const [userData, setUserData] = useState(null);
  const [bubbleHeight, setBubbleHeight] = useState(100);
  const levels = [2, 4, 6, 8, 10];

  // We added this
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        const data = await response.json();
        setUserData(data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  // -- isLevelUnlocked (matching the pattern in Exercise2Intro/Exercise3Intro)
  const isLevelUnlocked = (levelNumber) => {
    if (!userData) return false;
    if (
      7 < userData.numExercisesUnlocked ||
      (7 === userData.numExercisesUnlocked &&
        levelNumber <= userData.currNumLevelsUnlocked)
    ) {
      return true;
    }
    return false;
  };
  
  const handleLevelClick = (level) => {
    setSelectedLevel(level);
  };

  const handleStartClick = () => {
    navigate("/exercise7workout");
  };

  let handleNextNextClick = () => {
    setBubbleHeight(150);
    setSunnyHTML(
      `<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
      Maintain <b>Rhythmic Breathing</b>. Let understanding emerge naturally. If comprehension slips, remain calm and relaxed. Let thoughts align with the text.
    </span>`
    );

    setCanStart(true);
  };

  let handleNextClick = () => {
    setSunnyHTML(
      `<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
    Text from the article will flash on the screen. Relax and focus.
  </span>`
    );
  };

  const renderButton = () => {
    if (canStart) {
      return (
        <button
          className="guidance-and-start-button"
          onClick={handleStartClick}
        >
          Start
        </button>
      );
    } else {
      return (
        <button
          className="guidance-and-start-button"
          onClick={
            sunnyHTML.includes("Select") ? handleNextClick : handleNextNextClick
          }
        >
          Next
        </button>
      );
    }
  };

  // We added this
  return (
    <div className="exercise1-intro-container">
      <div className="intro-content">
        <p className="hint">Complete levels to unlock more</p>
      </div>
      <div className="sunny-intro">
        <img src={Star2} alt="sunny" className="sunny" />
        <IconBubble
          width={620}
          height={bubbleHeight}
          HTML={sunnyHTML}
          color="FFFFFF"
          fontSize={25}
        />
      </div>
      <div className="bottom-buttons">
        <div></div>
        {renderButton()}
      </div>
    </div>
  );
};

export default Exercise7Intro;
